/**
 * order-wizard.js — INTENTIONAL STUB
 *
 * The order-wizard code lives entirely in ai-designer.js now (starting at
 * approximately line 1560). This file exists only so the legacy
 * `sections/order-wizard.liquid` section, which still references
 * `{{ 'order-wizard.js' | asset_url }}`, doesn't 404 and crash pages.
 *
 * Symptoms of removing this stub:
 *   - "Failed to load resource: 404" for /assets/order-wizard.js
 *   - "Refused to execute script ... MIME type ('text/html') is not executable"
 *   - Downstream JS on the same page can fail to initialise (gang sheet
 *     builder body was invisible when this happened last time).
 *
 * When Roland is ready to fully retire the legacy section:
 *   1. Shopify admin → Online Store → Themes → Customize
 *   2. Find and remove the "Order Wizard" section from wherever it's
 *      currently embedded (usually theme.liquid header/footer group)
 *   3. Then this stub file can be deleted from Assets.
 *
 * Until then, keep this here — it's 20 bytes, does nothing, and prevents
 * the whole cascade.
 */
(function () {
  if (window.console && console.info) {
    console.info("[order-wizard.js] stub loaded — real implementation lives in ai-designer.js");
  }
})();
